import Api from './Api';
import Configuracao from '../util/Configuracao';

class ProfissionalApi extends Api {
  async consultarNomesTodosProfissionais () {
    try {
      const nomesUrl = Configuracao.getConfiguracao().urlConsultarNomesTodosProfissionais;
      const response = await this.fetch(nomesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEspecialidades () {
    try {
      const especialidadesUrl = Configuracao.getConfiguracao().urlConsultarEspecialidades;
      const response = await this.fetch(especialidadesUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarEspecialidadesPermitidas (seqPrestador) {
    try {
      const especialidadesPermitidasUrl = Configuracao.getConfiguracao().urlConsultarEspecialidadesPermitidas + seqPrestador;
      const response = await this.fetch(especialidadesPermitidasUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarCROs () {
    try {
      const CROsUrl = Configuracao.getConfiguracao().urlConsultarCROs;
      const response = await this.fetch(CROsUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async consultarProfissionais (filter) {
    try {
      const profissionaisUrl = Configuracao.getConfiguracao().urlConsultarProfissionais +
      filter.seqPrestador + '/' +
      filter.seqProfissional + '/' +
      filter.seqCRO + '/' +
      filter.seqEspecialidade + '/' +
      filter.seqUF + '/' +
      filter.dataVigencia;

      const response = await this.fetch(profissionaisUrl);
      return response.data;
    } catch (error) {
      console.error(error);
    }
  }
  async incluirProfissional (profissional) {
    try {
      const urlIncluirProfissional = Configuracao.getConfiguracao().urlIncluirProfissional;
      const response = await this.fetch(urlIncluirProfissional, 'put', profissional);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async excluirProfissional (numProfissional) {
    try {
      const urlExcluirProfissional = Configuracao.getConfiguracao().urlExcluirProfissional + '/' + numProfissional;
      const response = await this.fetch(urlExcluirProfissional, 'post');
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async alterarProfissional (profissional) {
    try {
      const urlAlterarProfissional = Configuracao.getConfiguracao().urlAlterarProfissional;
      const response = await this.fetch(urlAlterarProfissional, 'put', profissional);
      return response;
    } catch (error) {
      console.error(error);
    }
  }
  async validarProfissional (profissional, indInclusao) {
    try {
      const urlValidarProfissional = `${Configuracao.getConfiguracao().urlValidarProfissional}/${indInclusao}`;
      const result = await this.fetch(urlValidarProfissional, 'POST', profissional, null, { 'content-type': 'text/plain' });

      return result;
    } catch (error) {
      console.error(error);
      return error;
    }
  }
}
export default ProfissionalApi;
